<template>
  <v-container>
    <v-dialog v-model="createUpdate" width="400" persistent>
      <v-card>
        <v-card-title>{{ selected.id ? 'Editar' : 'Crear' }} VMeter</v-card-title>
        <v-card-text>
          <v-form ref="createupdate" lazy-validation v-model="model">
            <v-row>
              <v-col>
                <v-switch v-model="selected.egauge" dense></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="selected.id"
                  dense
                  outlined
                  hide-details="auto"
                  label="Id"
                  :prefix="selected.egauge ? 'egauge' : 'vertebra'"
                  :rules="[rules.required]"
                  @keypress="isNumber($event)"
                  @keyup="checkId()"
                ></v-text-field>
                <small
                  v-if="selected.id"
                >{{ selected.egauge ? `http://egauge${selected.id}.egaug.es` : `https://vertebra${selected.id}.vertebrameters.com` }}</small>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="selected.nombre"
                  dense
                  outlined
                  hide-details
                  label="Nombre"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-switch v-model="selected.activo" dense label="¿Activo?"></v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="success"
            small
            @click="createOrUpdate()"
            :disabled="!model"
          >Guardar {{ selected.id ? 'Cambios' : '' }}</v-btn>
          <v-btn color="error" small @click="createUpdate = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col class="col-3">
        <v-text-field
          placeholder="Buscar VMeter..."
          v-model="search"
          append-icon="search"
          single-line
        ></v-text-field>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="primary"
          @click="selected = { activo: true }; edit = false; createUpdate = true"
        >Crear nuevo VMeter</v-btn>
      </v-col>
    </v-row>
    <v-data-table :headers="headers" :items="meters" :items-per-page="5" :search="search">
      <template v-slot:item.activo="{ item }">
        <!-- <v-switch v-model="item.activo"></v-switch> -->
        <v-checkbox v-model="item.activo" readonly></v-checkbox>
      </template>
      <template v-slot:item.acciones="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="warning"
              v-on="on"
              icon
              x-small
              @click="selected = item; selected._id = item.id; edit = true; createUpdate = true"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="error" v-on="on" icon x-small @click="remove(item)">
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import Vue from "vue";
import { apiv1 } from "@/libs/apiv1";
import { oAuth } from "../../../classes/Auth";

export default Vue.extend({
  name: "VMeters",
  data: () => ({
    selected: {},
    createUpdate: false,
    auth: oAuth,
    search: null,
    meters: [],
    model: true,
    edit: false,
    headers: [
      {
        text: "Id",
        value: "id"
      },
      {
        text: "Medidor",
        value: "nombre"
      },
      {
        text: "Activo",
        value: "activo"
      },
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        width: 200
      }
    ],
    rules: {
      required: v => !!v || "Este campo es requerido"
    }
  }),
  async created() {
    this.getVMeters();
  },
  methods: {
    async getVMeters() {
      const { data } = await apiv1({
        url: `vmeters/${oAuth.getProject().id}`,
        method: "GET"
      });

      this.meters = data;
    },
    async createOrUpdate() {
      if (this.$refs.createupdate.validate()) {
        let url = `vmeters`;
        let method = "POST";
        if (this.edit) {
          console.log(this.selected)
          url += `/${this.selected._id}`;
          method = "PUT";

          delete this.selected._id;
          delete this.selected.proyecto;
        }

        this.selected.proyecto = oAuth.getProject().id;

        const { data } = await apiv1({
          url: url,
          method: method,
          data: this.selected
        });

        await this.getVMeters();
        this.createUpdate = false;
        this.$awn.success(data);
      }
    },
    async remove(item) {
      this.$swal({
        title: "Continuar?",
        text: `¿Seguro que desea eliminar el VMeter '${item.nombre.toUpperCase()}'?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, deseo eliminarlo",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          apiv1({
            method: "DELETE",
            url: `vmeters/${item.id}`
          }).then(res => {
            this.getVMeters();
            this.$awn.success(res.data);
          });
        }
      });
    },
    async checkId() {
      try {
        const id = this.selected.id;
        const { data } = await apiv1({
          method: "GET",
          url: `vmeters/check-id/${this.selected.id}`
        });
      } catch (err) {
        console.log(err)
      }
    }
  }
});
</script>